import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperQuickAddIndividualView: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      padding: "24px",
    },
    containerItemFiled: {
      display: "flex",
      flexDirection: "row",
      gap: "32px",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    titleFiledItem: {
      width: "280px",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    wrapperInputFiled: {
      maxWidth: "512px",
      minWidth: "400px",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        minWidth: "100%",
      },
    },
    titleHeaderItem: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "28px",
      color: theme.palette.text.primary,
    },
    wrapperRadioButtons: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
    },
    containerEmailTitle: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
    sunTitleEmail: {
      marginBottom: "20px",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: theme.palette.text.tertiary,
      width: "280px",
    },
    phoneInputSection: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    headerQuickAddIndividualView: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: theme.spacing(2),
    },containerPercentageTitle:{
      display:'flex',
      gap:'8px',
      alignItems:'center'
    }
  };
});
